import { enums, idToLabel, storage } from '../../helpers/common';
import { dataPoints } from '../../helpers/meta';
import { actionTypes } from '../constants/action-types';

const startingData = [{}];
Object.keys(dataPoints).map((key) => {
    startingData[0][key] = 0;
})
var defaultUser = { login: false, token: "", access: [] };
var user = storage.getParsed(enums.USER, defaultUser);


const startingTable = (user) => {
    let stores = [];
    user.access.map((branch) => {
        var temp = {
            label: branch.label,
            _id: branch._id
        }
        Object.keys(dataPoints).map((key) => {
            temp[key] = 0;
        });
        stores.push(temp)

    })
    return stores

}
       

// var startingTable = user.access.map(branch => {
//         console.log('userA', user);
//         var temp = {
//             label: branch.label,
//             _id: branch._id
//         }
//         Object.keys(dataPoints).map((key) => {
//             temp[key] = 0;
//         });
//         return temp;
//     })

    const initialState = {
        totalCurrent: startingData,
        totalPrevious: startingData,
        current: startingTable(user),
        previous: startingTable(user),
    };

    export const summary = (state = initialState, { type, payload = {} }) => {
        switch (type) {
            case actionTypes.SUMMARY:
                payload.current = payload.current.map(val => {
                    return { ...val}
                });
                payload.prev = payload.prev.map(val => {
                    return { ...val}
                });
                payload.total_current = payload.total_current.map(val => {
                    return { ...val}
                });
                payload.total_prev = payload.total_prev.map(val => {
                    return { ...val}
                });
                var _current = payload.current.length ? payload.current : startingTable(payload.user);
                var _previous = payload.prev.length ? payload.prev : startingTable(payload.user);
                var totalCurrent = payload.total_current.length ? payload.total_current : startingData;
                var totalPrevious = payload.total_prev.length ? payload.total_prev : startingData;
               


                var current = _current.map((row) => {
                    return { ...row, label: row.label }
                })
                var previous = _previous.map((row) => {
                    return { ...row, label: row.label }
                });
                return { ...state, current: current, previous: previous, totalCurrent: totalCurrent, totalPrevious: totalPrevious };
            default:
                return state;
        }
    }



